module.exports = __webpack_public_path__ + "img/boy.39b67ef3.png";